module.exports = __webpack_public_path__ + "images/feature/1218_doc_md_2-211748fd288b44fe4a28a617c258a548.jpg";